export default __webpack_public_path__ + "img/yeah.b318d634.svg";